module.exports = __webpack_public_path__ + "img/一桌好菜.663d0be9.png";